<template>
    <div id="swiper-wrapper">

    <Row class="swiper_row">
        <Col span="0.5">
          <div class="success-left-div" @click="prevBtn">
            <img src="../assets/img/success-left.png" width="50%">
          </div>
        </Col>
        <Col>
          <div>
            <swiper ref="mySwiper" :options="swiperOption">
              <swiper-slide class="recommend-item" v-for="item of recommends" :key="item.goodsId">
                <div class="carousel-content">
                  <div class="content-a" :style="item.goodsName==''?'opacity:0':''">
                      <img :src="item.image" :style="item.image==''?'height:0':''" width="40%"/>
                      <h4>{{item.goodsName}}</h4>
                      <p>{{item.goodsContent}}</p>
                      <p v-if="item.goodsContent==''" style="opacity: 0;">学校于 2003 年开始建设校园网，采用传统以太网协议按照“核心--汇聚--接入”的三层网络架构进行建设..</p>
                      <router-link :to="{path:'successDetails',query:{num:item.goodsId}}">
                        <p class="success-p">{{item.more}}</p>
                      </router-link>
                  </div>
                </div>
              </swiper-slide>

            </swiper>
          </div>
        </Col>
      <Col span="0.5">
          <div class="success-right-div">
            <img src="../assets/img/success-right.png" @click="nextBtn" width="50%">
          </div>
        </Col>
      </Row>

  </div>
</template>

<script>
   import { Icon } from 'vant';
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css';
  export default {
    components: {
      [Icon.name]: Icon,
      Swiper,
      SwiperSlide,
    },
    props: {
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 3,
          autoplay: false,
          navigation: {
                   nextEl: '.swiper-button-next',
                   prevEl: '.swiper-button-prev',
                 }
        },
        recommends: [
          {
            goodsId:7,
            image:require("../assets/img/ty.png"),
            goodsName:"武汉体育学院校园网基础设施改造项目",
            goodsContent:"学校于 2003 年开始建设校园网，采用传统以太网协议按照“核心--汇聚--接入”的三层网络架构进行建设...",
            more:"MORE>>"
          },
          {
            goodsId:8,
						image:"",
            // image:require("../assets/img/xytsg.png"),
            goodsName:"襄阳市图书馆",
            goodsContent:"襄阳市图书馆总建筑面积约5.4万平方米，集藏、借、阅、管为一体，拥有纸质文献310万册（件）、音像...",
            more:"MORE>>"
          },
          {
            goodsId:9,
						image:"",
            // image:require("../assets/img/whtsg.png"),
            goodsName:"武汉图书馆",
            goodsContent:"武汉图书馆位于武汉市江汉区建设大道，是全国首批古籍重点保护单位、全国首批“数字图书馆推广工程...",
            more:"MORE>>"
          }
        ]
      }
    },
    methods:{
      prevBtn() {
        this.$refs.mySwiper.$swiper.slidePrev();
      },
      nextBtn() {
         this.$refs.mySwiper.$swiper.slideNext();
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .ddd{
    width: 40px;
  }
  .ccc{
    width: 40px;
  }
#swiper-wrapper{
  position: relative;
}
  .success-left-div {
    // padding-top: 1rem;
    position: absolute;
    left: 0;
    top: 50%;
    width: 35px;
    margin-top: -18.8px;
     z-index: 15;
      cursor: pointer;
  }
  .success-right-div{
    position: absolute;
    right: -18px;
    top: 50%;
    width: 35px;
    margin-top: -18.8px;
    z-index: 15;
    cursor: pointer;
    img{
      // margin-left: 100%;
    }
  }
  .carousel-content{
    text-align: center;
    padding: 0 7%;
    .content-a{
 	background-image: linear-gradient(0deg,
		#fdfdfd 50%,
		#f4f5fa 100%);
      height: 3.2rem;
      img{
        margin-top: 0.4rem;
        // height: 0.4rem;
        height: 23.9px;
        margin-bottom: 0.2rem;
      }
      h4{
        	font-family: SourceHanSansCN-Medium;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253954;
      }
      p{
        margin-top: 0.2rem;
        padding: 0 0.2rem;
        text-align: left;

        	font-family: SourceHanSansCN-Medium;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253954;
  font-size: 12px;
  height: 70px;
      }
      .success-p{
        text-align: right;
        color: #5ac1ff;
        cursor: pointer;
      }
    }
  }
  .ivu-tabs-nav-prev{
    top: 12px;
     color: #5ac1ff;
  }
  .ivu-tabs-nav-next{
    top: 12px;
        color: #5ac1ff;
  }
</style>



// WEBPACK FOOTER //
// src/util/SuccessEducate.vue